module.exports = __webpack_public_path__ + "media/customizations/caymas/logo-27ddb3fb5f1e3ae43bfd89994a61fab2.png";